import { render, staticRenderFns } from "./PageLoader.vue?vue&type=template&id=3e2acda6&scoped=true&"
import script from "./PageLoader.vue?vue&type=script&lang=js&"
export * from "./PageLoader.vue?vue&type=script&lang=js&"
import style0 from "./PageLoader.vue?vue&type=style&index=0&id=3e2acda6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2acda6",
  null
  
)

export default component.exports